"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionBar = ActionBar;
exports.default = void 0;
var _core = require("@blueprintjs/core");
var React = _interopRequireWildcard(require("react"));
var _buttonStyle = require("../../common/buttonStyle");
var _cardLevel = require("../../common/cardLevel");
var _classes = require("../../common/classes");
var _Button = require("../button/Button");
var _IconButton = require("../button/IconButton");
var _Card = require("../card/Card");
var _Divider = require("../divider/Divider");
var _iconNames = require("../icon/iconNames");
var _Frow = require("../layout/Frow");
var _Popover = require("../popover/Popover");
var _typography = require("../typography/typography");
var _excluded = ["cancelIcon", "children", "elevated", "isOpen", "text", "cardLevel", "cancelText", "onCancel", "showCancelText", "style"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ItemDivider() {
  return /*#__PURE__*/React.createElement(_Divider.Divider, {
    muted: true,
    style: {
      height: '24px'
    }
  });
}
function ActionBar(_ref) {
  var _ref$cancelIcon = _ref.cancelIcon,
    cancelIcon = _ref$cancelIcon === void 0 ? 'CROSS_CIRCLE' : _ref$cancelIcon,
    children = _ref.children,
    elevated = _ref.elevated,
    isOpen = _ref.isOpen,
    text = _ref.text,
    cardLevel = _ref.cardLevel,
    cancelText = _ref.cancelText,
    onCancel = _ref.onCancel,
    _ref$showCancelText = _ref.showCancelText,
    showCancelText = _ref$showCancelText === void 0 ? true : _ref$showCancelText,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var items = React.Children.toArray(children).map(function (item, index) {
    return {
      id: index,
      ref: /*#__PURE__*/React.createRef(),
      component: item
    };
  });
  // Setting a sensible default on the itemWidths so they're never undefined;
  var _React$useState = React.useState(Array(items.length).fill(200)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    itemWidths = _React$useState2[0],
    setItemWidths = _React$useState2[1];
  var _React$useState3 = React.useState(items),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    visibleItems = _React$useState4[0],
    setVisibleItems = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    overflowItems = _React$useState6[0],
    setOverflowItems = _React$useState6[1];
  var _React$useState7 = React.useState(200),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    parentWidth = _React$useState8[0],
    setParentWidth = _React$useState8[1];
  var _React$useState9 = React.useState(450),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    actionBarWidth = _React$useState10[0],
    setActionBarWidth = _React$useState10[1];
  function maybeRenderOverflowList() {
    if (overflowItems.length === 0) return null;
    return /*#__PURE__*/React.createElement(_Popover.Popover, {
      position: _core.Position.BOTTOM_RIGHT,
      usePortal: false,
      targetClassName: _classes.Classes.ACTION_BAR_OVERFLOW_BUTTON
    }, /*#__PURE__*/React.createElement(_IconButton.IconButton40, {
      icon: _iconNames.IconNames16.ELLIPSIS_HORIZONTAL
    }), /*#__PURE__*/React.createElement(_Frow.Frow, {
      flexDirection: "column"
    }, overflowItems.map(function (item) {
      return itemRenderer(item);
    })));
  }
  function handleActionBarResize(entries) {
    var actionBar = entries.find(function (entry) {
      return entry.target.classList.contains(_classes.Classes.ACTION_BAR);
    }) || entries[0];
    var newActionBarWidth = Math.floor(actionBar.contentRect.width);
    setActionBarWidth(newActionBarWidth);
  }
  function handleResize(entries) {
    var parent = entries.find(function (entry) {
      return entry.target.classList.contains(_classes.Classes.ACTION_BAR_WRAPPER);
    }) || entries[0];
    var newParentWidth = Math.floor(parent.contentRect.width);
    setParentWidth(newParentWidth);
  }

  /**
   * Repartition the items when the width of the parent container changes
   */
  React.useEffect(function () {
    var total = 0;
    var newVisible = [];

    /**
     * If we've got no parentWidth then just default to showing the first item.
     * This is just a sensible default.
     */
    if (!parentWidth) {
      newVisible.push(items[0]);
    } else {
      var availableSpace = parentWidth;
      items.forEach(function (item) {
        total += itemWidths[item.id];
        if (total < availableSpace) newVisible.push(item);
      });
    }
    setVisibleItems(newVisible);
    var sliceLength = items.length - newVisible.length;
    var overflowed = sliceLength > 0 ? items.slice(-sliceLength) : [];
    setOverflowItems(overflowed);
  }, [parentWidth]);

  /**
   * Calculate the item widths on load.
   * Have added a fallback value of 200 os apparently the ref.current might not exist..
   */
  React.useEffect(function () {
    var newItemWidths = items.map(function (item) {
      return item.ref.current ? item.ref.current.offsetWidth : 200;
    });
    setItemWidths(newItemWidths);
  }, []);
  function itemRenderer(item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      ref: item.ref,
      className: _classes.Classes.ACTION_BAR_ITEM
    }, item.component);
  }

  /**
   * This whole component will shit its pants if there's no space for the menu
   */
  var showText = text && actionBarWidth >= 450;
  return /*#__PURE__*/React.createElement(_core.ResizeSensor, {
    onResize: handleActionBarResize
  }, /*#__PURE__*/React.createElement(_Card.Card, _extends({
    className: _classes.Classes.ACTION_BAR,
    elevated: elevated || false,
    level: cardLevel || _cardLevel.CardLevel.FILLED,
    padded: false,
    style: style
  }, props), /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap"
  }, /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center",
    flexWrap: "nowrap",
    style: {
      flexGrow: 1
    }
  }, showText && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_typography.Body, {
    className: _classes.Classes.ACTION_BAR_TEXT
  }, text), /*#__PURE__*/React.createElement(ItemDivider, null)), /*#__PURE__*/React.createElement(_core.ResizeSensor, {
    onResize: handleResize
  }, /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.ACTION_BAR_WRAPPER
  }, visibleItems.map(function (item) {
    return itemRenderer(item);
  }), maybeRenderOverflowList()))), onCancel ? /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ItemDivider, null), /*#__PURE__*/React.createElement(_Button.Button, {
    icon: _iconNames.IconNames16[cancelIcon],
    onClick: onCancel,
    text: showCancelText ? cancelText || 'Cancel' : '',
    buttonStyle: _buttonStyle.ButtonStyle.TERTIARY
  })) : null)));
}
var _default = ActionBar;
exports.default = _default;